import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { StorageApi } from '../../utils/storageApi';
import { UNAUTHORIZED, TOTP_CODE_REQUIRED } from './../common/handleApiCall';
import { fetchGetUserData } from './userData';

//- Actions
export const onForbidden = createAction('SET_FORBIDDEN');
export const onServerError = createAction('SET_SERVER_ERROR');
export const onRefreshForbidden = createAction('REFRESH_FORBIDDEN');
export const logout = createAction('LOGOUT');

export const fetchAuthorizeFailed = createAction('FETCH_AUTHORIZE_FAILED');
export const fetchAuthorizeSuccess = createAction('FETCH_AUTHORIZE_SUCCESS');
export const fetchAuthorize2FARequired = createAction('FETCH_AUTHORIZE_2FA_REQUIRED');
export const onAuthorizeSuccess = (result) => (dispatch) => {
    dispatch(fetchAuthorizeSuccess(result.token));
    dispatch(fetchGetUserData());
}
export const onAuthorizeFailed = (error) => (dispatch) => {
    switch (error) {
        case UNAUTHORIZED:
            dispatch(fetchAuthorizeFailed("INCORRECT_USERNAME_OR_PASSWORD"));
            break;

        case TOTP_CODE_REQUIRED:
            dispatch(fetchAuthorize2FARequired());
            break;

        default:
            dispatch(fetchAuthorizeFailed(error));
            break;
    }
};

export const fetchAuthorize = createAction(
    'FETCH_AUTHORIZE',
    (data) => Api.getToken(data),
    () => ({
        apiCall: true,
        onSuccess: onAuthorizeSuccess,
        onFail: onAuthorizeFailed
    })
);

export const cleanLoginError = createAction('CLEAN_LOGIN_ERROR');
export const clean2FARequiredStatus = createAction('CLEAN_2FA_REQUIRED_STATUS');

//- State
const initialState = {
    isAuthorised: !!StorageApi.getLoginToken(),
    error: null,
    fetching: false,
    isForbidden: false,
    isServerError: false,
    is2FARequired: false
};

//- Reducers
export default handleActions({

    FETCH_AUTHORIZE: (state) => {        
        StorageApi.removeUserData();
        return { ...state, isAuthorised: false, error: null, fetching: true };
    },
    FETCH_UPDATE_AUTHORIZATION: (state) => {
        return { ...state, error: null, fetching: true };
    },
    FETCH_AUTHORIZE_FAILED: (state, action) => {
        StorageApi.removeLoginToken();
        return { ...state, isAuthorised: false, error: action.payload, fetching: false };
    },
    FETCH_AUTHORIZE_2FA_REQUIRED: (state) => {
        return { ...state, isAuthorised: false, is2FARequired: true, fetching: false };
    },
    FETCH_AUTHORIZE_SUCCESS: (state, action) => {
        StorageApi.setLoginToken(action.payload);        
        return { ...state, isAuthorised: true, error: null, fetching: false, is2FARequired: false };
    },
    LOGOUT: (state) => {
        StorageApi.removeLoginToken();
        StorageApi.removeUserData();
        return { ...state, isAuthorised: false, error: null };
    },
    SET_FORBIDDEN: (state) => {
        return { ...state, isForbidden: true };
    },
    SET_SERVER_ERROR: (state) => {
        return { ...state, isServerError: true };
    },
    REFRESH_FORBIDDEN: (state) => {
        return { ...state, isForbidden: false };
    },
    CLEAN_LOGIN_ERROR: (state) => {
        return { ...state, error: null };
    },
    CLEAN_2FA_REQUIRED_STATUS: (state) => {
        return { ...state, is2FARequired: false };
    }

}, initialState);


//- Selectors
export const getLogin = state => state.login;

export const getLoginAuthoriseStatus = state => getLogin(state).isAuthorised;

export const getLoginFetchingStatus = state => getLogin(state).fetching;

export const getLoginError = state => getLogin(state).error;

export const getIs2FARequired = state => getLogin(state).is2FARequired;

export const isForbidden = state => getLogin(state).isForbidden;

export const isServerError = state => getLogin(state).isServerError;


// WEBPACK FOOTER //
// ./src/reducers/account/login.js